export const getShouldInitContextSync = (): boolean => !!window.__SHOULD_INIT_CONTEXT_SYNC__;

export const popShouldInitContextSync = (): boolean => {
  const shouldContextInitSync = window.__SHOULD_INIT_CONTEXT_SYNC__;
  delete window.__SHOULD_INIT_CONTEXT_SYNC__;

  return shouldContextInitSync;
};
